exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mapSelectDiv{\r\n    border: 2px dashed #0000c4;\r\n    background: #5a72f8;\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    filter: alpha(opacity:10);\r\n    opacity: 0.2\r\n}", ""]);

// exports
